// extracted by mini-css-extract-plugin
export default {"arrowButton":"SeeMoreSmallButton_arrowButton__kLOBZ","arrowIcon":"SeeMoreSmallButton_arrowIcon__UTJ2v"};